import { useModal } from '@context/ModalContext';
import { type Value } from '@discover-use-router-state';
import useQueryState from '@discover-use-query-state';

type QUERY_VALUE = 'open' | null;

const DEFAULT_QUERY_VALUE = null;

type STATE_VALUE = boolean;

function getValid(queryValues: Value[]): QUERY_VALUE {
  if (queryValues.length === 0) {
    return DEFAULT_QUERY_VALUE;
  }

  const queryValue = queryValues[0];

  if (queryValue === undefined || queryValue === null) {
    return DEFAULT_QUERY_VALUE;
  }

  if (queryValue === 'open') {
    return 'open';
  }

  return DEFAULT_QUERY_VALUE;
}

export default function useMapQueryState(): [STATE_VALUE, (newOpen: STATE_VALUE) => void] {
  const { hideModal, isModalOpen } = useModal();
  const [queryValue, setQueryValue] = useQueryState('map', getValid, DEFAULT_QUERY_VALUE);

  const open = queryValue === 'open';

  async function setOpen(newOpen: boolean) {
    await setQueryValue(newOpen ? 'open' : null);

    if (!newOpen && isModalOpen) {
      hideModal();
    }
  }

  return [open, setOpen];
}
